import { atom } from 'jotai';

export const isExistNotReadChatMessageAtom = atom<boolean>(false);
